import { toast } from "react-toastify";

/**
 * Notificar
 * @param {string} tipo tipo de notificación, info/success/error/warn
 * @param {string} msg mensaje
 * @param {integer} autoClose delay en milisegundos
 */
export const Notificar = (tipo = null, msg, autoClose = null) => {
  const posicion = toast.POSITION.TOP_CENTER;

  switch(tipo){
    case "success":
      toast.success(msg, {
        autoClose: autoClose === null ? 10000 : autoClose,
        position: posicion,
      });
      break;
    case "error":
      toast.error(msg, {
        autoClose: autoClose === null ? false : autoClose,
        position: posicion,
      });
      break;
    case "warn":
      toast.warn(msg, {
        autoClose: autoClose === null ? 10000 : autoClose,
        position: posicion,
      });
      break;
    case "info":
    default:
      toast.info(msg, {
        autoClose: autoClose === null ? 5000 : autoClose,
        position: posicion,
      });
  }
};